// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "suggestions-3puC9";
var _3 = "container-2hjkp";
var _4 = "text-24HW0";
var _5 = "money-e_N7S";
export { _1 as "__esModule", _2 as "suggestions", _3 as "container", _4 as "text", _5 as "money" }
export default { "__esModule": _1, "suggestions": _2, "container": _3, "text": _4, "money": _5 }
